import { fetchApiData, fetchApiDataV2 } from "../../utils/utils";
import axios from 'axios';

export const getShows = async (appInfo, data, type) => {
  const filterRequired = appInfo?.projectDetails?.projectConfig?.config?.CUSTOM_FILTERS_REQUIRED;
  if (filterRequired) {
    let uid = localStorage.getItem("gid");
    let user_id = localStorage.getItem("userId");
    let countryCode = appInfo?.projectDetails?.geoInfo?.countryCode;
    let ipaddress = appInfo?.projectDetails?.geoInfo?.query;
    let deviceId = appInfo?.projectDetails?.device_id;
    let token = appInfo?.accessToken;
    let pubid = appInfo?.projectDetails?.projectConfig?.pubid;
    let channelid = appInfo?.projectDetails?.projectConfig?.channelid;
    let deviceType = localStorage.getItem("deviceType");
    if (user_id) {
      uid = user_id;
    }
    const customConfig = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": true,
        crossorigin: true,
        "access-token": token,
        uid: uid,
        pubid: pubid,
        country_code: countryCode,
        channelid: channelid,
        dev_id: deviceId,
        ip: ipaddress,
        device_type: deviceType ? deviceType : "web",
      }
    };
    const api = "show/search";
    try {
      const postData = data || {};
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_V2}${api}`,
        postData,
        customConfig
      );
      return response;
    } catch (err) {
      throw err;
    }
  
  } else {
    const api = "show/search";
    const params = {};
    if (data) {
      params.key = data;
    }
    if (type) {
      params.type = type;
    }
    return await fetchApiDataV2(appInfo, api, params);
  }
};

export const getSearchFilters = async (appInfo) => {
  const api = "search/filters";
  return await fetchApiData(appInfo, api);
};